import { Box, MantineSize, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import app_serverResources from "../@resource-interfaces/app_serverResources"

type AppServerLocalizableString = keyof app_serverResources

interface Props extends React.PropsWithChildren {
  label: AppServerLocalizableString | string
  placeholder?: string
  valueAsText?: boolean
  size?: MantineSize
}

export function Property({
  label,
  children: value,
  placeholder,
  valueAsText,
  size,
}: Props) {
  const { t } = useTranslation("app_server")
  return (
    <Box>
      <Text c="bright" fw={500} size={size}>
        {t(label as AppServerLocalizableString)}
      </Text>
      {value === null && placeholder ? (
        <Text c="dimmed" fs="italic" size={size}>
          {placeholder}
        </Text>
      ) : typeof value === "string" || valueAsText ? (
        <Text size={size}>{value}</Text>
      ) : (
        value
      )}
    </Box>
  )
}
